module.exports = __webpack_public_path__ + "static/media/star-small.9b910f6a.svg";